import React, { useState, useEffect, useMemo } from "react";
import {
  Form,
  Input,
  Button,
  Col,
  Row,
  Radio,
  Select,
  message,
  TimePicker,
  Checkbox,
  Calendar,
  DatePicker,
  Table,
} from "antd";
import styled from "styled-components";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Auxiliary from "util/Auxiliary";
import ModuleBreadcrumb from "components/Common/ModuleBreadcrumb";
import AppForm from "components/Common/AppForm";
import { useDispatch, useSelector } from "react-redux";
import SearchBox from "../../../components/Common/AppTable/SearchBox";
import {
  requestAllUserDetails,
  requestAttendanceAdd,
} from "../../../appRedux/actions/User";
import { useCallback } from "react";
import { debounce, set } from "lodash";
import { getAllUser, getUser } from "../../../appRedux/selectors/User";
import { getAuthUser } from "../../../appRedux/selectors/Auth";

const Addattendance = () => {
  const [form] = Form.useForm();
  const [userListCount, setUserListCount] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [searchBarText, setSearchBarText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const Users = useSelector(getAllUser);
  const AuthUsers = useSelector(getAuthUser);
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  console.log(selectedRowKeys, "sfsdsdfsd", selectedKeys);

  const usersData = useMemo(() => {
    if (Users && Users.length) {
      return Users.map((a) => {
        return {
          ...a,
          key: a._id,
        };
      });
    }
    return [];
  }, [Users]);

  const getFromQueryParam =
    new URLSearchParams(useLocation()?.search)?.get("from") || null;

  // Initial Params for fetching users
  const initialParams = useMemo(() => {
    if (userListCount && getFromQueryParam === "add") {
      return {
        ...userListCount,
      };
    }
    return {
      q: searchBarText,
    };
  }, []);

  //Fetch User Details
  useEffect(() => {
    dispatch(requestAllUserDetails(initialParams));
  }, [initialParams]);

  // On Search it will fetch the User Name
  const onSearchHandler = (values) => {
    const params = {
      ...initialParams,
      q: values ? values : "",
    };

    dispatch(requestAllUserDetails(params));
  };

  // Add Debounce to search for performance and prevent to extra call
  const onSearchDebounce = useCallback(
    debounce((text) => {
      onSearchHandler(text);
      setSearchBarText(text);
    }, 700),
    []
  );

  const onSearchTextChangeHandler = (text) => {
    if (text) {
      let uniqueArray = [...selectedKeys, ...selectedRowKeys].filter(
        (item, i, ar) => ar.indexOf(item) === i
      );
      setSelectedKeys(uniqueArray);
    } else {
      let myuniqueArray = [...selectedRowKeys, ...selectedKeys].filter(
        (item, i, ar) => ar.indexOf(item) === i
      );
      setSelectedRowKeys(myuniqueArray);
    }
    onSearchDebounce(text);
  };

  const onSelectChange = (keys) => {
    setSelectedRowKeys(keys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onSubmitFormHandler = async (values) => {
    const userData = {
      ...values,
      users: selectedRowKeys,
      date: values?.date.format("DD-MM-YYYY"),
      admin: AuthUsers?._id,
    };
    dispatch(requestAttendanceAdd(userData));
  };

  const columns = useMemo(() => {
    return [
      {
        title: "Name",
        dataIndex: "user_name",
      },
      {
        title: "Contact",
        dataIndex: "mobile",
      },
    ];
  }, []);

  return (
    <AttendanceStyle>
      <Auxiliary>
        <ModuleBreadcrumb
          title="Nikol Bal-Sabha Attendance"
          breadcrumbs={["Attendance", "Add"]}
          links={["/attendance", "/attendance", ""]}
        />
        <Row className="gx-profile-content">
          <Col span={24}>
            <div className="gx-card">
              <div className="gx-card-body">
                <AppForm
                  className="app-forms"
                  scrollToFirstError={{
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                  }}
                  onFinish={onSubmitFormHandler}
                  form={form}
                >
                  <Row>
                    <div className="flex-between">
                      <div>
                        <SearchBox
                          placeholder="Search..."
                          value={userListCount?.q || ""}
                          // length={restaurantsData?.length}
                          styleName="gx-lt-icon-search  -bar-lg"
                          searchText={searchText}
                          setSearchText={setSearchText}
                          onChange={(e) => onSearchTextChangeHandler(e)}
                        />
                      </div>
                      <div style={{ marginRight: "20px" }} className="pl15">
                        <Form.Item
                          name="date"
                          rules={[
                            {
                              required: true,
                              message: "Date is required!",
                            },
                          ]}
                        >
                          <DatePicker />
                        </Form.Item>
                      </div>
                    </div>
                  </Row>
                  <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={usersData}
                    pagination={false}
                  />
                  <div className="gx-text-center gx-pt-3">
                    <Form.Item>
                      <Button
                        className="gx-mb-0"
                        onClick={() => history.push("/attendance/view")}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="gx-mb-0"
                        type="primary"
                        htmlType="submit"
                      >
                        Save
                      </Button>
                    </Form.Item>
                  </div>
                </AppForm>
              </div>
            </div>
          </Col>
        </Row>
      </Auxiliary>
    </AttendanceStyle>
  );
};

export default Addattendance;

const AttendanceStyle = styled.div`
  .phone-number {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-weight: 600;
  }
  .plus-icon {
    font-size: 25px;
    margin-left: 15px;
    display: flex;
    align-items: center;
  }
  .remove-btn {
    background: rgb(230, 68, 60);
    border-radius: 25px;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    margin-top: 15px;
    &:hover {
      background: rgb(230, 68, 60);
      color: rgb(255, 255, 255);
      border: rgb(230, 68, 60);
    }
  }
  .logo {
    width: 235px;
    height: 235px !important;
    border-radius: 6px;
    margin-top: 10px;
  }
  .ant-radio-inner::after {
    top: 10.5px;
    left: 11px;
  }
  .platform-select
    .ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-radius: 6px !important;
    height: 36px;
    align-items: center;
  }
  .flex {
    display: flex;
    gap: 15px;
  }
  .flex-between {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: 0 20px 0px 20px;
  }
  .border-bottom {
    padding-bottom: 7px;
    border-bottom: 1px solid black;
  }
  .stylesearchbar {
    width: 315px;
    left: 8px;
  }
  @media screen and (max-width: 520px) {
    .flex-between {
      flex-direction: column-reverse;
    }
    .gx-card-body {
      padding: 15px !important;
    }
    .pl15 {
      padding-left: 15px;
    }
    table tr td.ant-table-selection-column {
      padding-right: 4px;
      padding-left: 4px;
      text-align: center;
    }
  }
`;
